<div class="login">
    <h1>Reset Password</h1>
    <form id="password-reset-form" #resetPasswordForm="ngForm">
      <div class="form-group">
        <p>Username (your email address)</p>
        <div class="form-group">
            <input aria-label=""  type="email" [(ngModel)]="resetPasswordVM.username"
                    name="login" class="auth-input" (focus)="tooltip.close()"
                    placeholder="Username (your email address)" required autofocus>
          </div>
        <p>New Password</p>
        <input aria-label=""  [type]="showPassword ? 'text' : 'password'" id="password"
        [(ngModel)]="resetPasswordVM.password"
        name="password" (focus)="tooltip.close()"
        class="auth-input" placeholder="Password" triggers="manual" placement="right"
        [ngbTooltip]="tipContent" #tooltip="ngbTooltip" required>
        <p>Confirm Password</p>
        <input aria-label=""  [type]="showPassword ? 'text' : 'password'" id="confirmpassword"
        [(ngModel)]="resetPasswordVM.confirm"
        name="confirmpassword" (focus)="tooltip.close()"
        class="auth-input" placeholder="Confirm Password" triggers="manual" placement="right"
        [ngbTooltip]="tipContent" #tooltip="ngbTooltip" required>
        <ng-template #tipContent>{{resetPasswordErrorMessage}}</ng-template>
        <div class="label info red no-margin-top" *ngIf="passwordValidationError !== ''">
          {{passwordValidationError}}
        </div>
        <div class="label info green no-margin-top" *ngIf="passwordResetSuccessMessage !== ''">
          {{passwordResetSuccessMessage}}
        </div>
      </div>
      <div class="form-group text-right">
        <button type="submit" class="auth-submit" 
                (click)="onPasswordChange()">
          Change Password
        </button>
        <a class="forgot-link" [routerLink]="['/login']">
          Login
        </a>        
      </div>

    </form>
  </div>
